const STORAGE_KEY = 'FW_ACCOUNT_PREFERENCE_V1';
export const ACCOUNT_PREFERENCE_TTL = 24 * 60 * 60 * 1000;

export const getAccountIdentity = (account) => account?.homeAccountId ||
  String(account?.userName || account?.username || '').trim().toLowerCase();

export const clearAccountPreference = () => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage may be disabled; account selection must still work.
  }
};

export const rememberAccount = (account, user) => {
  const identity = getAccountIdentity(account);
  if (!identity) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
      identity,
      employeeId: String(user.emp_id),
      companyId: String(user.emp_company_id),
      expiresAt: Date.now() + ACCOUNT_PREFERENCE_TTL,
    }));
  } catch {
    // A preference is optional, even when storage is unavailable.
  }
};

export const getRememberedAccount = (account, users) => {
  try {
    const preference = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    if (!preference) return null;
    if (!Number.isFinite(preference.expiresAt) || preference.expiresAt <= Date.now()) {
      clearAccountPreference();
      return null;
    }
    const identity = getAccountIdentity(account);
    if (!identity || preference.identity !== identity) return null;
    // Always use the current server response, never cached employee details or permissions.
    const user = users.find(candidate =>
      String(candidate.emp_id) === preference.employeeId &&
      String(candidate.emp_company_id) === preference.companyId);
    if (!user) clearAccountPreference();
    return user || null;
  } catch {
    clearAccountPreference();
    return null;
  }
};
